import { Text } from "@instructure/ui-text";
import { TopNavBar } from "@instructure/ui-top-nav-bar";
import { View } from "@instructure/ui-view";
import { useTranslation } from "react-i18next";
import logo from "../../src/logo-white-yellow.png";

const TopNav = () => {
  const { t } = useTranslation();

  return (
    <TopNavBar breakpoint={2}>
      {() => (
        <TopNavBar.Layout
          navLabel={t("navigation.publicNav")}
          smallViewportConfig={{
            dropdownMenuToggleButtonLabel: t("navigation.toggleMenu"),
            dropdownMenuLabel: t("navigation.mainMenu"),
          }}
          renderBrand={
            <TopNavBar.Brand
              screenReaderLabel={t("navigation.brandName")}
              renderIcon={
                <>
                  <img
                    alt={t("navigation.logoAlt")}
                    style={{ width: "74px", margin: "0 auto" }}
                    src={logo}
                  />
                  <View as="div" minWidth="7rem">
                    <Text
                      as="div"
                      color="primary-inverse"
                      size="large"
                      weight="normal"
                      lineHeight="condensed"
                    >
                      {t("navigation.insights")}
                    </Text>
                  </View>
                </>
              }
            />
          }
        />
      )}
    </TopNavBar>
  );
};

export default TopNav;
